module.exports = __webpack_public_path__ + "img/doc_view_list.4ef9c881.png";